import React from 'react';
import BaseHeader from '../common/layout/BaseHeader';
import StyledComponent from '../core/StyledComponent';
import BaseFooter from '../common/layout/BaseFooter';
import { BuilderComponent, BuilderComponentProps, DesignMode, generateBackgroundObject, useNode } from '@mnz/builder';
import Box from '@mui/material/Box';
import { Plus } from '@menuzen/icon/build/outline';
import { hoverAnimationCss } from '../common/style';

interface DocumentProps extends BuilderComponentProps {
    openBlockModal: () => void;
}
export const Document: BuilderComponent<DocumentProps> = ({ designSettings, children, account, openBlockModal }) => {
    const {
        query: { getOptions },
    } = useNode();

    const canEdit = getOptions().enabled;
    const isLiveMode = getOptions().mode === DesignMode.LIVE;
    return (
        <StyledComponent
            xs={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                maxWidth: 750,
                marginLeft: 'auto',
                marginRight: 'auto',
                position: 'relative',
                ...generateBackgroundObject(designSettings),
            }}
        >
            <BaseHeader isLiveMode={isLiveMode} designSettings={designSettings} />
            <StyledComponent xs={{ flexGrow: 1, paddingBottom: '12px' }}>
                {children}
                {canEdit && (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginTop: '16px',
                            paddingX: '15px',
                            padding: '16px 43px',
                            marginX: '35px',
                            cursor: 'pointer',
                            backgroundColor: '#fff',
                            borderRadius: '10px',
                            boxSizing: 'border-box',
                            fontWeight: '600',
                            color: (theme) => theme.palette.primary50,
                            fontFamily: (theme) => theme.typography.fontFamily,
                            ...hoverAnimationCss({ hoverCss: { color: (theme) => theme.palette.success.main } }),
                        }}
                        onClick={openBlockModal}
                    >
                        <Plus />
                        Add Block
                    </Box>
                )}
            </StyledComponent>

            <BaseFooter isLiveMode={isLiveMode} designSettings={designSettings} account={account} />
        </StyledComponent>
    );
};

Document.defaultProps = {};
Document.settings = {
    displayName: 'Document',
    rules: {
        canDrag: () => false,
    },
    related: {},
};
